import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';

// NOTE: The backend sends all dates as Europe/Berlin time
export const localizeDate = (date: Date): Date => {
  return new Date(formatInTimeZone(fromZonedTime(date, 'Europe/Berlin'), 'UTC', "yyyy-MM-dd'T'HH:mm:ssXX"));
};
